import React from 'react';
import styled from 'styled-components';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../../componentes/componentes_generales/componentes_formulario/labels/';
import NumeroComprobante from '../componentes_generales/numeroComprobante/numeroComprobante';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { validarCampoString, validarJSON } from '../../funciones_globales/utils';
import { multiplicarDecimales } from '../../funciones_globales/operacionesMatematicas';
import { formatearNumeroDecimal } from '../../funciones_globales/format';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargar_Factura, cargar_PagosPorFactura, inicializarFactura } from '../../actions/ventas/act_ven02';
import { seleccionar_NumeroComprobante } from '../../actions/generales/act_gen04';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';

const ContenedorModal = styled.div`
  margin-top: 20px;
  height: 300px;
  width: 700px;
`;

const LabelValor = styled.label`
  display: inline-block;
  font-size: 10px;
  color: green;
  margin-left: 5px;
  font-weight: bold;
  margin-top: 3px;
`;

const TituloModalPagos = styled.h5`  
  color: green;
  font-weight: bold;
`;

const COD_BOTON_PAGOSCONTABLE = '040901';

class FormVen09 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {
      totalDsctoPlazo:0,//2020-06-19 WILLY CEDEÑO DSCTO PLAZO
      porcentajeDsctoPlazo:0,//2020-06-19 WILLY CEDEÑO DSCTO PLAZO
      isVisibleModalPagos: false,
      detalleFactura: [],
      pagosFactura: [],
      tituloModalPagos: '',
      isVisibleBotonPagosContab: false,

      colsDefDetFactura: [
          {   header: "No.",
              field: "NroItem",
              width: 40,
              type: "string",
              suppressFilter: true
          },
          {   header: "Artículo",
              field: "Articulo",
              width: 85,
              type: "string"
          },
          {   header: "Descripción",
              field: "Descripcion",
              width: 320,
              type: "string"
          },
          {   header: "Marca",
              field: "Marca",
              width: 210,
              type: "string"
          },                            
          {   header: "Cant.",
              field: "Cantidad",
              width: 70,
              type: "num_entero",
              suppressFilter: true
          },
          {   header: "Precio",
              field: "Precio",
              width: 80,
              type: "num_decimal",
              suppressFilter: true
          },
          {   header: "% Dscto.",
              field: "Descuento",
              width: 80,
              type: "num_entero",
              suppressFilter: true
          },
          
          {   header: "Subtotal",
              field: "Subtotal",
              width: 90,
              type: "num_decimal",
              suppressFilter: true,

              valueGetter: (params) => {
                /* Cálculo del subotal de cada item de la factura, se considera el descuento por línea de artículo */
                let cantidad = parseFloat(Number.isNaN(params.data.Cantidad)? 0: params.data.Cantidad);
                let precioUnit = parseFloat(Number.isNaN(params.data.Precio)? 0: params.data.Precio);
                let porcDescuento = parseFloat(Number.isNaN(params.data.Descuento)? 0: params.data.Descuento);    
                let porcDescuentoPlazo= params.data.Articulo.trim()==='EMBA'?0:this.state.porcentajeDsctoPlazo;////DSCTO PLAZO 20200623 WILLY    
                let precioUnitDscto = parseFloat(multiplicarDecimales(precioUnit, porcDescuento/100));                
                let precioUnitDescontado = parseFloat(parseFloat(precioUnit)-parseFloat(precioUnitDscto));                
                let subTotalItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDescontado)).toFixed(2);
                let valorDsctoPlazo= parseFloat(multiplicarDecimales(subTotalItem, porcDescuentoPlazo/100)).toFixed(2);
                subTotalItem=parseFloat(parseFloat(subTotalItem)-parseFloat(valorDsctoPlazo)).toFixed(2);
                return subTotalItem;
              }
          },
          {   header: "Es Promoc.",
              field: "EsPromocion",
              width: 80,
              type: "string",
              suppressFilter: true
          },
        ],
    colsDefPagosFact: [
          {   header: "No.",
              field: "NroItem",
              width: 30,
              type: "string",
              suppressFilter: true
          },
          {   header: "T. Mov.",
              field: "TipoMovimiento",
              width: 70,
              type: "string"
          },
          {   header: "Movimiento",
              field: "Movimiento",
              width: 80,
              type: "string"
          },
          {   header: "Fecha",
              field: "Fecha",
              width: 65,
              type: "string",
              suppressFilter: true
          },
          {   header: "Banco",
              field: "Banco",
              width: 110,
              type: "string",
              suppressFilter: true
          },
          {   header: "Cuenta",
              field: "Cuenta",
              width: 80,
              type: "string",
              suppressFilter: true
          },
          {   header: "Cheque",
              field: "Cheque",
              width: 65,
              type: "string",
              suppressFilter: true
          },
          {   header: "F. Vcto.",
              field: "Vencimiento",
              width: 65,
              type: "string",
              suppressFilter: true
          },
          {   header: "V. Efect.",
              field: "ValorEfectivo",
              width: 65,
              type: "num_decimal",
              suppressFilter: true
          },
          {   header: "V. Cheque",
              field: "ValorCheque",
              width: 65,
              type: "num_decimal",
              suppressFilter: true
          },
          {   header: "V. Dep.",
              field: "ValorDeposito",
              width: 65,
              type: "num_decimal",
              suppressFilter: true
          },
          {   header: "Observaciones",
              field: "Observacion",
              width: 200,
              type: "string",
              suppressFilter: true
          },
        ],
    };

    this.gridDetFacturaOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressRowClickSelection: true
    };

    this.gridPagosFactOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressRowClickSelection: true
    };

    this.onGridDetFacturaReady = this.onGridDetFacturaReady.bind(this);
    this.onGridPagosFacturaReady = this.onGridPagosFacturaReady.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getFacturabyId = this.getFacturabyId.bind(this);
    this.generarReporteFactura = this.generarReporteFactura.bind(this);
    this.generarReporteComprobContable = this.generarReporteComprobContable.bind(this);
    this.consultarPagosPorFactura = this.consultarPagosPorFactura.bind(this);
    this.limpiar = this.limpiar.bind(this);
  }
  
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onGridDetFacturaReady(params){
    this.apiDetFact = params.api;
    this.columnApiDetFact = params.columnApi;
  }

  onGridPagosFacturaReady(params){
    this.apiPagosFact = params.api;
    this.columnApiPagosFact = params.columnApi;
  }

  componentDidMount() {
    let usuario = getItemDatosSesion('usuario');

    Promise.all([
      cargarPermisoBoton(COD_BOTON_PAGOSCONTABLE, usuario),
      this.props.generar_LogAuditoriaIngresoForm('0409')
    ])
    .then(([configBotonPagosContab]) => {
      let isVisibleBotonPagosContab = false;

      if(configBotonPagosContab.display==='block'){
        isVisibleBotonPagosContab = true;
      }

      this.setState({isVisibleBotonPagosContab});
    })
    .catch(error => {
      alert(error);
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0409');
  }

  getFacturabyId(){
    try {
      if (!validarCampoString(this.props.numeroFactura, 17)){
        alert('No ha especificado el No. de Factura a consultar.');
        return;
      }
  
      let establec = this.props.numeroFactura.slice(0, 3);
      let ptoEmision = this.props.numeroFactura.slice(4,7);
      let secuencial = this.props.numeroFactura.slice(8);
      this.setState({totalDsctoPlazo:0, porcentajeDsctoPlazo:0})
      this.props.cargar_Factura(establec, ptoEmision, secuencial)
      .then(()=>{
        try {
          if(validarJSON(this.props.facturaSel)){
            let detalleFactura = [];
            this.props.facturaSel.detFactura.forEach((itemDetFact)=>{
              detalleFactura.push({
                NroItem: itemDetFact.Secuencia,
                Articulo: itemDetFact.art.Codigo,
                Descripcion: itemDetFact.art.Nombre,
                Marca: `${itemDetFact.art.marca.Codigo} - ${itemDetFact.art.marca.Descripcion}`,
                Cantidad: itemDetFact.Cantidad,
                Precio: itemDetFact.Precio,
                Descuento: itemDetFact.Descuento,
                EsPromocion: (itemDetFact.EsPromocion===true?'*':''),
                DescuentoPlazo:itemDetFact.PorcentajeDsctoPlazo//2020-06-19 WILLY CEDEÑO DSCTO PLAZO
              });
            });
            //2020-06-19 WILLY CEDEÑO DSCTO PLAZO
            this.setState({detalleFactura, porcentajeDsctoPlazo:this.props.facturaSel.PorcentajeDsctoPlazo, totalDsctoPlazo:this.props.facturaSel.TotalDsctoPlazo});
          }
        } catch (error) {
          alert(error);
        }
      });
    } catch (error) {
      alert(`Ocurrió un error al consultar la factura. Error: ${error}`);
    }  
  }

  generarReporteFactura(){    
    let facturaId = this.props.facturaSel.Factura;
    if (!validarCampoString(facturaId, 6)){
      alert('No ha seleccionado una Factura para imprimir.');
      return;
    }

    visualizarReporteEnPdf(`&rpt=3&param1=${facturaId}`);
  }

  generarReporteComprobContable(){
    let comprobContableId = this.props.facturaSel.cont.Movimiento;
    if (!validarCampoString(comprobContableId, 7)){
      alert('No ha seleccionado una Factura para imprimir el Comprobante Contable.');
      return;
    }

    visualizarReporteEnPdf(`&rpt=27&param1=${comprobContableId}`);
  }

  consultarPagosPorFactura(tipoConsulta){
    let facturaId = this.props.facturaSel.Factura;

    if (!validarCampoString(facturaId, 6)){
      alert('No ha seleccionado una factura para consultar pagos.');
      return;
    }

    this.props.cargar_PagosPorFactura(facturaId, tipoConsulta)
    .then(()=>{
      if (validarJSON(this.props.facturaSel.pagos)){
        this.setState({
          isVisibleModalPagos: true,
          tituloModalPagos: `DETALLE DE PAGOS (${tipoConsulta==='PCLI'?'Cliente':'Contable'}):`
        });
      }
    });
  }

  inicializarPtoFacturacionDeNumeroFactura(){
    let puntoFacturacionDefault;

    for(let i=0; i<this.props.puntosFacturacion.length; i++){
      if (this.props.puntosFacturacion[i].EsDefault==='S'){
          puntoFacturacionDefault = this.props.puntosFacturacion[i];
          break;
      }
    }    
    let numeroComprobante = puntoFacturacionDefault.Establecimiento + '-' + puntoFacturacionDefault.PtoEmision;
    this.props.seleccionar_NumeroComprobante(numeroComprobante);
  }

  limpiar(){
    try {
      this.props.inicializarFactura();
      this.inicializarPtoFacturacionDeNumeroFactura();
      this.setState({
        totalDsctoPlazo:0,
        porcDsctoGlobal:0,
        isVisibleModalPagos: false,
        detalleFactura: [],
        tituloModalPagos: ''
      });  
    } catch (error) {
     alert(`Ocurrió un error al intentar inicializar la pantalla. Error: ${error}`);
    }
  }

  render(){
      
    let cliente ='', vendedor ='', fecha ='', pedidoMovil ='', proforma ='', formaPago ='',
        terminoPago ='', estado ='', diasGracia ='', saldo ='', saldoCont = '', estadoCont = '',
        valorGravaIva ='', valorNoGravaIva ='', dsctoLinea ='',
        porcDsctoGlobal ='', dsctoGlobal ='', porcIva ='', iva ='', total ='', totalCheques =0,
        totalEfectivo =0, totalDepositos =0, totalPagos =0;

      let pagosFactura = [];
      if (validarJSON(this.props.facturaSel.pagos)){
        this.props.facturaSel.pagos.forEach((pago, i) =>{
          pagosFactura.push({
            NroItem: i+1,
            ...pago
          });
          
          totalCheques += parseFloat(pago.ValorCheque===null?0:pago.ValorCheque);
          totalEfectivo += parseFloat(pago.ValorEfectivo===null?0:pago.ValorEfectivo);
          totalDepositos += parseFloat(pago.ValorDeposito===null?0:pago.ValorDeposito);
        });
        totalPagos = totalCheques + totalEfectivo + totalDepositos;
      }

      if (validarJSON(this.props.facturaSel)){
        cliente = `${this.props.facturaSel.cli.Codigo} - ${this.props.facturaSel.cli.Nombre}`;
        vendedor = `${this.props.facturaSel.vend.Codigo} - ${this.props.facturaSel.vend.Nombre}`;
        fecha = this.props.facturaSel.Fecha;
        total = this.props.facturaSel.Importe;
        pedidoMovil = this.props.facturaSel.prof.PedidoMovil;
        proforma = this.props.facturaSel.Pedido;
        formaPago = this.props.facturaSel.FormaPago;
        terminoPago = this.props.facturaSel.TerminoPago;
        diasGracia = this.props.facturaSel.Gracia;
        estado = `${this.props.facturaSel.est.Estado}-${this.props.facturaSel.est.Nombre}`;
        saldo = this.props.facturaSel.Saldo===null?0:this.props.facturaSel.Saldo;
        valorGravaIva = this.props.facturaSel.TotalConIva===null?0:this.props.facturaSel.TotalConIva;
        valorNoGravaIva = this.props.facturaSel.TotalSinIva===null?0:this.props.facturaSel.TotalSinIva;
        dsctoLinea = this.props.facturaSel.DescuentoLinea===null?0:this.props.facturaSel.DescuentoLinea;
        porcDsctoGlobal = this.props.facturaSel.Descuento===null?0:this.props.facturaSel.Descuento;
        dsctoGlobal = this.props.facturaSel.ValorDescuento===null?0:this.props.facturaSel.ValorDescuento;
        porcIva = this.props.facturaSel.PorcentajeIva===null?'':this.props.facturaSel.PorcentajeIva;
        iva = this.props.facturaSel.Iva===null?0:this.props.facturaSel.Iva;
        total = this.props.facturaSel.Importe===null?0:this.props.facturaSel.Importe;
        saldoCont = this.props.facturaSel.SaldoContable===null?0:this.props.facturaSel.SaldoContable;
        estadoCont = this.props.facturaSel.estCont===null?'':(`${this.props.facturaSel.estCont.Estado}-${this.props.facturaSel.estCont.Nombre}`);
      }

      return(
        <div>
          <ContenedorForm porc_ancho={80}>
            <HeaderForm>
              <TituloForm>Consulta de Factura</TituloForm>
            </HeaderForm>
            <CuerpoForm>
              <Row>
                <ContainerCol className='col-sm-3 '>
                  <LabelForm>No. Factura:</LabelForm>
                  <NumeroComprobante placeholder='No. Factura' funcBuscarComprobante={this.getFacturabyId}
                    func_OnFocus={this.limpiar}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-5'>
                  <LabelForm>Cliente:</LabelForm>
                  <LabelValor>{cliente}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-5'>
                  <LabelForm>Vendedor:</LabelForm>
                  <LabelValor>{vendedor}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Fecha:</LabelForm>
                  <LabelValor>{fecha}</LabelValor>
                </ContainerCol>                
              </Row>
              <Row>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Proforma:</LabelForm>
                  <LabelValor>{proforma}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Pedido Móvil:</LabelForm>
                  <LabelValor>{pedidoMovil}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Forma Pago:</LabelForm>
                  <LabelValor>{formaPago}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Término Pago:</LabelForm>
                  <LabelValor>{terminoPago}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Días Gracia:</LabelForm>
                  <LabelValor>{diasGracia}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Estado:</LabelForm>
                  <LabelValor>{estado}</LabelValor>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Saldo:</LabelForm>
                  <LabelValor>{saldo!==''?formatearNumeroDecimal(saldo):''}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Est. Cont.:</LabelForm>
                  <LabelValor>{estadoCont}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Saldo Cont.:</LabelForm>
                  <LabelValor>{saldoCont!==''?formatearNumeroDecimal(saldoCont):''}</LabelValor>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <AgGridRender altura='320px' data={this.state.detalleFactura} columnas={this.state.colsDefDetFactura}
                    gridOptions={this.gridDetFacturaOptions} onGridReady={this.onGridDetFacturaReady}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-1'>
                  <LabelForm>Base Iva:</LabelForm>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Base Sin Iva:</LabelForm>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Dscto. Línea:</LabelForm>
                </ContainerCol>            
                <ContainerCol className='col-sm-2'>
                  <LabelForm>{`Dscto. Global (${porcDsctoGlobal}%):`}</LabelForm>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>{`Dscto. Por Plazo(${this.state.porcentajeDsctoPlazo}%):`}</LabelForm>
                </ContainerCol>   
                <ContainerCol className='col-sm-1'>
                  <LabelForm>{`Iva (%${porcIva}):`}</LabelForm>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Total: </LabelForm>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-1'>
                  <LabelValor>{formatearNumeroDecimal(valorGravaIva)}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelValor>{formatearNumeroDecimal(valorNoGravaIva)}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelValor>{formatearNumeroDecimal(dsctoLinea)}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelValor>{formatearNumeroDecimal(dsctoGlobal)}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelValor>{formatearNumeroDecimal(this.state.totalDsctoPlazo)}</LabelValor>
                </ContainerCol>   
                <ContainerCol className='col-sm-1'>
                  <LabelValor>{formatearNumeroDecimal(iva)}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelValor>{formatearNumeroDecimal(total)}</LabelValor>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <div className='btn-group pull-right'>
                    <button type='button' className='btn btn-primary btn-sm' onClick={()=>{this.consultarPagosPorFactura('PCLI')}}>
                      <i className='fa fa-money fa-lg'/> Ver Pagos (Cliente)</button>
                    {this.state.isVisibleBotonPagosContab?
                      <button type='button' className='btn btn-sm' onClick={()=>{this.consultarPagosPorFactura('PCONT')}}>
                        <i className='fa fa-money fa-lg'/> Ver Pagos (Contab.)
                      </button>
                    :null}
                    <button type='button' className='btn btn-info btn-sm' isVisible
                      onClick={this.generarReporteFactura}><i className='fa fa-print fa-lg'/> Imp. Factura</button>
                    <button type='button' className='btn btn-success btn-sm' onClick={this.generarReporteComprobContable}><i className='fa fa-print fa-lg'/> Imp. Comp. Contable</button>
                    <button type='button' className='btn btn-default btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                  </div>
                </ContainerCol>
              </Row>
            </CuerpoForm>
          </ContenedorForm>
          <ModalResponsive open={this.state.isVisibleModalPagos} onClose={()=>{this.setState({isVisibleModalPagos:false})}}
            ocultarClose={true}>
            <ContenedorModal>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <TituloModalPagos>{this.state.tituloModalPagos}</TituloModalPagos>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <AgGridRender altura='350px' data={pagosFactura} columnas={this.state.colsDefPagosFact}
                    gridOptions={this.gridPagosFactOptions} onGridReady={this.onGridPagosFacturaReady}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-3'>
                  <LabelForm>Total Cheques:</LabelForm>
                  <LabelValor>{formatearNumeroDecimal(totalCheques)}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                  <LabelForm>Total Efectivo:</LabelForm>
                  <LabelValor>{formatearNumeroDecimal(totalEfectivo)}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                  <LabelForm>Total Depósitos:</LabelForm>
                  <LabelValor>{formatearNumeroDecimal(totalDepositos)}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                  <LabelForm>Total Pagos:</LabelForm>
                  <LabelValor>{formatearNumeroDecimal(totalPagos)}</LabelValor>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <div className='btn-group pull-right'>                  
                    <button type='button' className='btn btn-primary btn-sm'
                      onClick={()=>{this.setState({isVisibleModalPagos:false})}}>OK</button>
                  </div>
                </ContainerCol>
              </Row>
            </ContenedorModal>
          </ModalResponsive>
        </div>
    );
  }
}

const mapStateToProps = state =>{
  return {  isVisibleLoading: state.ui.isVisibleLoading,
            numeroFactura: state.generales.numComprobSel,
            facturaSel: state.ventas.facturaSel,
            puntosFacturacion: state.ventas.puntosFact
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, 
        generar_LogAuditoriaSalidaForm,
        cargar_Factura,
        cargar_PagosPorFactura,
        inicializarFactura,
        seleccionar_NumeroComprobante
       }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen09);